export const formItems = {
  reason: 'reason',
  gender: 'gender',
  name: 'name',
  addition: 'tussenvoegsel',
  lastname: 'lastname',
  phoneNumber: 'phoneNumber',
  email: 'email',
  zipcode: 'zipcode',
  housenumber: 'housenumber',
  streetname: 'streetname',
  city: 'city',
  office: 'office',
  remarks: 'remarks',
};

export const transformDataForAPI = (values: any) => {
  const data = {
    token: 'aaabbbccaabbaabbaabbcccccccccccc',
    serviceRequestType: 'AFSPRAAKVERZOEK',
    source: getAppSource(),
    comments: values[formItems.remarks],
    officeId: values[formItems.office].officeId,
    savePhoneNumber: false,
    telephoneNumber: values[formItems.phoneNumber],
    addressPostalCode: values[formItems.zipcode],
    addressHousenumber: values[formItems.housenumber],
    email: values[formItems.email],
    infix: values[formItems.addition],
    initials: values[formItems.name],
    lastName: values[formItems.lastname],
    gender: values[formItems.gender],
    reasonForAppointment: values[formItems.reason],
    addressStreet: values[formItems.streetname],
    addressCity: values[formItems.city],
    url: window.location.href,
  };

  return data;
};

function getAppSource() {
  const path = window.location.pathname;
  let source = 'Internet';

  if (path.includes('fundamliapp') || path.includes('fundamlimobile')) {
    source = 'Funda';
  }

  return source;
}
